/** AUX: pick your own music files; they play in order through the trotro speaker. */
export class Aux {
  private readonly audio = new Audio();
  private tracks: File[] = [];
  private index = 0;
  private url: string | null = null;
  private source: MediaElementAudioSourceNode | null = null;
  onTrack: (name: string) => void = () => undefined;

  constructor() {
    this.audio.addEventListener('ended', () => this.play(this.index + 1));
  }

  get hasTracks(): boolean {
    return this.tracks.length > 0;
  }

  /** Opens the file picker. Resolves true if tracks were chosen. */
  choose(): Promise<boolean> {
    return new Promise((resolve) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'audio/*';
      input.multiple = true;
      input.addEventListener('change', () => {
        this.tracks = [...(input.files ?? [])];
        resolve(this.tracks.length > 0);
      });
      input.click();
    });
  }

  /** Routes the player through the speaker chain (only once per element). */
  connect(ctx: AudioContext, speaker: AudioNode): void {
    if (this.source) return;
    this.source = ctx.createMediaElementSource(this.audio);
    this.source.connect(speaker);
  }

  play(index = this.index): void {
    if (this.tracks.length === 0) return;
    this.index = ((index % this.tracks.length) + this.tracks.length) % this.tracks.length;
    const track = this.tracks[this.index];
    if (!track) return;
    if (this.url) URL.revokeObjectURL(this.url);
    this.url = URL.createObjectURL(track);
    this.audio.src = this.url;
    void this.audio.play().catch(() => undefined);
    this.onTrack(track.name.replace(/\.[^.]+$/, ''));
  }

  skip(): void {
    this.play(this.index + 1);
  }

  stop(): void {
    this.audio.pause();
  }

  pause(): void {
    this.audio.pause();
  }

  resume(): void {
    void this.audio.play().catch(() => undefined);
  }
}
